import { Flex, Box, Icon } from '../component-library';
import { useVideo } from '../context/videoContext';
import { LocalVideo, RemoteVideo } from '../2022-component-library/src/components/shared';
import styled from '@emotion/styled';

const Room = ({ stacked, children, customStyle, parentVideoRef }) => {
  const VideoRefreshOverlay = styled(Flex)`
    background-color: rgba(0, 0, 0, 0.2);
    width: ${stacked ? '30px' : '40px'};
    height: ${stacked ? '30px' : '40px'};
    border-radius: 50%;
    margin: 10px;
    position: absolute;
    z-index: 1;
    justify-content: center;
    align-items: center;

    &:hover {
      background-color: rgba(0, 0, 0, 0.3);
      cursor: pointer;
    }

    & svg {
      display: block !important;
    }
  `;

  const { reconnect } = useVideo();

  const refreshVideo = () => {
    reconnect();
  };

  const getVideoChatBox = () => {
    return (
      <Flex
        className='room'
        width='100%'
        mt='20px'
        flexDirection={stacked ? 'column' : 'row'}
        alignItems='center'
        style={customStyle ? customStyle.videoBox : {}}
      >
        <Flex flexDirection='column' alignItems='center'>
          <Box
            className='local-participant'
            width={stacked ? '240px' : '490px'}
            height={stacked ? '160px' : '328px'}
            overflow='hidden'
            borderRadius='30px'
            boxShadow='0px 11px 22px #B9D5D5'
            style={customStyle ? customStyle.localParticipant : {}}
          >
            <VideoRefreshOverlay
              onClick={() => {
                refreshVideo();
              }}
            >
              <Icon icon='loop2' size={stacked ? 15 : 25} color='white' />
            </VideoRefreshOverlay>
            <LocalVideo parentVideoRef={parentVideoRef} disableBorderRadius />
          </Box>
        </Flex>

        <Flex flexDirection='column' alignItems='center'>
          <Box
            className='remote-participants'
            width={stacked ? '240px' : '490px'}
            height={stacked ? '160px' : '328px'}
            overflow='hidden'
            borderRadius='20px'
            boxShadow='0px 11px 22px #B9D5D5'
            mt={stacked ? '30px' : '0px'}
            ml={stacked ? '0px' : '30px'}
            style={customStyle ? customStyle.remoteParticipant : {}}
          >
            <RemoteVideo disableBorderRadius />
          </Box>
        </Flex>
        {stacked ? (
          <Flex width='100%' mt='30px' flexDirection='column' justifyContent='center' alignItems='center'>
            {children}
          </Flex>
        ) : null}
      </Flex>
    );
  };

  return getVideoChatBox();
};

export default Room;
